import { Expose, Type } from 'class-transformer';
import { BookedStatusEnum } from '../../../store/events/eventTypes';
import { MyActivityWithRelationsImpl } from './my-activity-with-relations.impl';
import { MyActivitiesTypeEnum } from '../../event/dto/enums/my-activities-type.enum';
import { EventWithRelationsImpl } from '../../event/dto/implements/event-with-relations.impl';

export class MyActivityEventImpl extends MyActivityWithRelationsImpl {
  @Expose({ name: 'event_id' })
  eventId: number;
  @Expose({ name: 'event' })
  @Type(() => EventWithRelationsImpl)
  event: EventWithRelationsImpl;
  @Expose({ name: 'status' })
  status: BookedStatusEnum;
  @Expose({ name: 'type' })
  type: MyActivitiesTypeEnum.FITNESS | MyActivitiesTypeEnum.EVENTS;
}
